import React from "react";
import { ContentType, DestinationType } from "../constants";
import { closePopUp, showAlertPopUp, showPopUp } from "./utils/Overlay";
import { ENV } from "../constants";
import Activity from "./utils/icons/Activity";

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
var days = ["Sun", "Mon", "Tues", "Wed", "Thur", "Fri", "Sat"];

export function areYouSure(
  ok: Function,
  message: JSX.Element | string = "Are you sure?"
) {
  return () => {
    showPopUp(
      <>
        {typeof message === "string" ? (
          <h3 className="tac mb1">{message}</h3>
        ) : (
          message
        )}
        <div className="center">
          <button
            className="primary ib mr1"
            onClick={() => {
              closePopUp();
              ok();
            }}
          >
            Yes
          </button>
          <button
            className="primary"
            onClick={() => {
              closePopUp();
            }}
          >
            No
          </button>
        </div>
      </>
    );
  };
}
export function message(str: string) {
  alert(str);
}
export function trim(
  str: string,
  length: number,
  appendLength = false
): string {
  const l = str.length;
  if (l > length) {
    return str.substr(0, length) + "…" + (appendLength ? ` (${l})` : "");
  }
  return str;
}
export function formatContent(c: Content): string {
  if (c.type === ContentType.TEXT) {
    return trim(c.value, 20, true);
  }
  return c.type;
}
export function formatDestination(
  d: Destination,
  context: "button" | "text" | "just-icon" = "button",
  icon: boolean = true
) {
  if (context === "just-icon") {
    icon = true;
  }
  if (d.type === DestinationType.TWITTER) {
    return (
      <>
        {icon && (
          <img
            src={
              context === "button"
                ? "/assets/img/twitter_white.png"
                : "/assets/img/twitter.png"
            }
            alt="twitter"
            width={20}
            className="ib vam"
          />
        )}
        {context !== "just-icon" &&
          ` Twitter (@${(d.meta as DestinationTwitterMeta).handle})`}
      </>
    );
  } else if (d.type === DestinationType.FACEBOOK) {
    return (
      <>
        {icon && (
          <img
            src={
              context === "button"
                ? "/assets/img/facebook_white.png"
                : "/assets/img/facebook.png"
            }
            alt="facebook"
            width={20}
            className="ib vam"
          />
        )}
        {context !== "just-icon" &&
          ` Facebook (${(d.meta as DestinationFacebookMeta).name})`}
      </>
    );
  } else if (d.type === DestinationType.MAILCHIMP) {
    return (
      <>
        {icon && (
          <img
            src={
              context === "button"
                ? "/assets/img/mailchimp_white.png"
                : "/assets/img/mailchimp.png"
            }
            alt="mailchimp"
            width={20}
            className="ib vam"
          />
        )}
        {context !== "just-icon" &&
          ` Mailchimp (${(d.meta as DestinationMailchimpMeta).name})`}
      </>
    );
  } else if (d.type === DestinationType.INSTAGRAM) {
    return (
      <>
        {icon && (
          <img
            src={
              context === "button"
                ? "/assets/img/instagram_white.png"
                : "/assets/img/instagram.png"
            }
            alt="instagram"
            width={20}
            className="ib vam"
          />
        )}
        {context !== "just-icon" &&
          ` Instagram (${(d.meta as DestinationInstagramMeta).name})`}
      </>
    );
  } else if (d.type === DestinationType.YOUTUBE) {
    return (
      <>
        {icon && (
          <img
            src={
              context === "button"
                ? "/assets/img/youtube_white.png"
                : "/assets/img/youtube.png"
            }
            alt="YouTube"
            width={20}
            className="ib vam"
          />
        )}
        {context !== "just-icon" &&
          ` YouTube (${(d.meta as DestinationYouTubeMeta).name})`}
      </>
    );
  } else if (d.type === DestinationType.LINKEDIN) {
    return (
      <>
        {icon && (
          <img
            src={
              context === "button"
                ? "/assets/img/linkedin_white.png"
                : "/assets/img/linkedin.png"
            }
            alt="LinkedIn"
            width={20}
            className="ib vam"
          />
        )}
        {context !== "just-icon" &&
          ` LinkedIn (${(d.meta as DestinationLinkedinMeta).name})`}
      </>
    );
  } else if (d.type === DestinationType.CUSTOM_BACKEND) {
    return (
      <>
        {icon && (
          <img
            src={
              context === "button"
                ? "/assets/img/server_white.png"
                : "/assets/img/server.png"
            }
            alt="Custom backend"
            width={20}
            className="ib vam"
          />
        )}
        {context !== "just-icon" &&
          ` Custom back-end (${(d.meta as DestinationCustomBackendMeta).name})`}
      </>
    );
  } else if (d.type === DestinationType.GROUP) {
    return (
      <>
        {icon && (
          <img
            src={
              context === "button"
                ? "/assets/img/group_white.png"
                : "/assets/img/group.png"
            }
            alt="Destination group"
            width={20}
            className="ib vam"
          />
        )}
        {context !== "just-icon" &&
          ` Destination group (${(d.meta as DestinationGroupMeta).name})`}
      </>
    );
  }
  return d.type;
}
export function formatDestinationAsString(d: Destination) {
  if (d.type === DestinationType.TWITTER) {
    return `Twitter (@${(d.meta as DestinationTwitterMeta).handle})`;
  } else if (d.type === DestinationType.FACEBOOK) {
    return `Facebook (${(d.meta as DestinationFacebookMeta).name})`;
  } else if (d.type === DestinationType.MAILCHIMP) {
    return `Mailchimp (${(d.meta as DestinationMailchimpMeta).name})`;
  } else if (d.type === DestinationType.INSTAGRAM) {
    return `Instagram (${(d.meta as DestinationInstagramMeta).name})`;
  } else if (d.type === DestinationType.YOUTUBE) {
    return `YouTube (${(d.meta as DestinationYouTubeMeta).name})`;
  } else if (d.type === DestinationType.LINKEDIN) {
    return `LinkedIn (${(d.meta as DestinationLinkedinMeta).name})`;
  } else if (d.type === DestinationType.CUSTOM_BACKEND) {
    return `Custom back-end (${(d.meta as DestinationCustomBackendMeta).name})`;
  } else if (d.type === DestinationType.GROUP) {
    return `Destination group (${(d.meta as DestinationGroupMeta).name})`;
  }
  return d.type;
}
export function formatDate(d: Date, noTime: boolean = false) {
  const printNum = (n) => (n < 10 ? "0" + n : n);
  const timeStr = `, ${printNum(d.getHours())}:${printNum(d.getMinutes())}`;

  return (
    <span>
      {months[d.getMonth()]} {d.getDate()}, {days[d.getDay()]},{" "}
      {d.getFullYear()}
      {noTime ? "" : timeStr}
    </span>
  );
}
export function formatDateAsString(d: Date, noTime = false): string {
  const printNum = (n) => (n < 10 ? "0" + n : n);

  if (noTime) {
    return `${d.getFullYear()} ${months[d.getMonth()]} ${d.getDate()}`;
  }
  return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}, ${printNum(
    d.getHours()
  )}:${printNum(d.getMinutes())}`;
}
export function getMonthName(date: Date) {
  return months[date.getMonth()];
}
export function formatTime(d: Date): string {
  const printNum = (n) => (n < 10 ? "0" + n : n);
  const timeStr = `${printNum(d.getHours())}:${printNum(d.getMinutes())}`;

  return timeStr;
}
export function bytesToSize(bytes) {
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes == 0) return "0 Byte";
  // @ts-ignore
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  // @ts-ignore
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
}
export function getParameter(parameterName): string | null {
  let result: null | string = null;
  let tmp: string[] = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) {
        result = decodeURIComponent(tmp[1]);
      }
    });
  return result;
}
export function isDefined(value) {
  return typeof value !== "undefined";
}
export function toSafeFilename(str: string): string {
  return (str || "").replace(/[^a-z0-9]/gi, "_").toLowerCase();
}
export function sortByDate(b, a) {
  if (
    a &&
    a.date &&
    a.date.toDate &&
    a.date.toDate().getTime &&
    b &&
    b.date &&
    b.date.toDate &&
    b.date.toDate().getTime
  ) {
    return a.date.toDate().getTime() - b.date.toDate().getTime();
  }
  return 0;
}

export function jobsToBuckets(jobs: Job[]): JobsBucket[] {
  return jobs.reduce((res: JobsBucket[], job) => {
    const d = job.date?.toDate() || new Date();
    const key: string = [d.getFullYear(), d.getMonth(), d.getDate()].join("_");
    let bucket = res.find((b) => b.key === key);
    if (!bucket) {
      res.push((bucket = { key, jobs: [] }));
    }
    bucket.jobs.push(job);
    return res;
  }, []);
}

export function keyToDate(key: string) {
  const [year, month, day] = key.split("_");
  return new Date(Number(year), Number(month), Number(day));
}

export function keyToFormattedDate(key: string) {
  return formatDate(keyToDate(key), true);
}

export function monthIdxToString(idx: number) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return months[idx] || "";
}

export function formatStatName(statName: keyof JobStats) {
  const map = {
    fb_likes: "Facebook(likes)",
    fb_comments: "Facebook(comments)",
    fb_shares: "Facebook(shares)",
    ig_likes: "Instagram(shares)",
    ig_comments: "Instagram(shares)",
    li_likes: "LinkedIn(likes)",
    li_comments: "LinkedIn(comments)",
    mc_opens: "Mailchimp(opens)",
    mc_clicks: "Mailchimp(clicks)",
    tw_retweets: "Twitter(retweets)",
    tw_likes: "Twitter(likes)",
    tw_comments: "Twitter(comments)",
    yt_views: "YouTube(views)",
    yt_likes: "YouTube(likes)",
    yt_dislikes: "YouTube(dislikes)",
    yt_comments: "YouTube(comments)",
    yt_favorite: "YouTube(favorite)",
  };
  return map[statName] || statName;
}

export function trackEvent(event, data = {}) {
  if (typeof gtag !== "undefined") {
    gtag("event", `${ENV}_${event}`, data);
  }
}

export function verifyRealUser(user: User, cb: Function) {
  if (user.demo) {
    showAlertPopUp(
      <>
        You are logged in as a demo user. Please log out and register to use
        this feature.
      </>
    );
    return;
  }
  cb();
}

export function CampaignStats({
  campaign,
  icon,
}: {
  campaign: Post;
  icon: boolean;
}) {
  const sourcesMap = {
    fb_likes: "Facebook",
    fb_comments: "Facebook",
    fb_shares: "Facebook",
    // Instagram
    ig_likes: "Instagram",
    ig_comments: "Instagram",
    // LinkedIn
    li_likes: "LinkedIn",
    li_comments: "LinkedIn",
    // mailchimp
    mc_opens: "Mailchimp",
    mc_clicks: "Mailchimp",
    // twitter
    tw_retweets: "Twitter",
    tw_likes: "Twitter",
    tw_comments: "Twitter",
    // youtube
    yt_views: "YouTube",
    yt_likes: "YouTube",
    yt_dislikes: "YouTube",
    yt_comments: "YouTube",
    yt_favorite: "YouTube",
  };
  if (campaign.stats && campaign.stats.engagements > 0) {
    const bySource = Object.keys(campaign.stats).reduce((res, field) => {
      if (sourcesMap[field]) {
        if (!res[sourcesMap[field]]) {
          res[sourcesMap[field]] = 0;
        }
        res[sourcesMap[field]] += campaign.stats[field];
      }
      return res;
    }, {});
    return (
      <p className="tac p1">
        {campaign.stats.engagements} user engagement
        {campaign.stats.engagements === 1 ? "" : "s"}
        <small className="op06 block">
          {Object.keys(bySource)
            .sort((a, b) => bySource[b] - bySource[a])
            .filter((key) => bySource[key] > 0)
            .map((key) => `${key}(${bySource[key]})`)
            .join(", ")}
        </small>
      </p>
    );
  }
  return null;
}
